import { styled } from '@uhg-abyss/web/tools/styled';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Tabs } from '@uhg-abyss/web/ui/Tabs';
import { Text } from '@uhg-abyss/web/ui/Text';

export const WidgetHeader = styled('div', {
  backgroundColor: '$providerDetailsDrawerHeaderBgColor',
  color: '$providerDetailsDrawerHeaderTextColor',
  maxWidth: '1200px',
  marginLeft: 'auto',
  marginRight: 'auto',
  padding: '16px 32px',
  '@media (max-width: 464px)': {
    padding: '16px',
  },
});

export const WidgetTabs = styled(Tabs, {
  '.abyss-tabs-tab': {
    backgroundColor: 'white',
    border: 'none',
  },
  '.abyss-tabs-tab-content': {
    fontSize: '$lg',
    fontWeight: 'bold',
    lineHeight: '$lg',
    textAlign: 'center',
    '& > div': {
      width: '100%',
    },
  },
  '.abyss-tabs-tab-active-line': {
    borderColor: '$core.color.neutral.80',
    borderRadius: '6px 6px 0px 0px',
  },
  '.abyss-tabs-list': {
    '& > div': {
      gap: '24px',
      width: '100%',
    },
    outline: '1px solid $cardBorder',
    display: 'flex',
    paddingLeft: '16px',
    paddingRight: '16px',
    textWrap: 'nowrap',
    button: {
      minWidth: 'unset',
      height: '52px',
      minHeight: '52px',
      padding: '20px 12px $sm 12px',
      width: '100%',
    },
    '.abyss-tabs-extended-border': {
      display: 'none',
    },
  },
});

export const ProviderInfo = styled(Layout.Stack, {
  paddingLeft: '24px',
  width: 'calc(100% - 84px)',
});

export const ProviderNameAndCost = styled(Layout.Group, {
  minHeight: '60px',
});

export const ProviderNameContainer = styled(Layout.Stack, {
  lineHeight: '20px',
});

export const ProviderName = styled(Heading, {
  display: 'inline-block',
  maxWidth: '275px',
  '&.abyss-heading-root': {
    color: '$providerDetailsDrawerHeaderHighlightColor !important',
    fontSize: '$lg',
    lineHeight: '24px',
    fontWeight: 'bold',
    fontFamily: '$primary',
  },
});

export const ProviderSpecialty = styled(Text, {
  display: 'inline-block',
  paddingBottom: '12px',
  fontFamily: '$primary',
});

export const BenefitsBadgeContainer = styled('div', {
  margin: '-4px 0 4px',
  '@media (max-width: 464px)': {
    marginBottom: '8px',
  },
});

export const CostEstimateContainer = styled(Layout.Stack, {
  lineHeight: '16px',
  '&.abyss-layout-stack': {
    marginBottom: '-3px',
  },
});

export const YouPayContainer = styled(Text, {
  fontSize: '14px',
});
export const OutOfPocketContainer = styled(Text, {
  fontSize: '20px !important',
});
export const TotalContainer = styled(Text, {
  fontSize: '12px',
});
export const WidgetSkeletonContainerHeader = styled('div', {
  background: '$providerDetailsDrawerHeaderLoadingBgColor',
  padding: '16px',
});

export const WidgetSkeletonContainer = styled('div', {
  background: 'white',
  maxWidth: '1200px',
  marginLeft: 'auto',
  marginRight: 'auto',
  display: 'block',
});

export const WidgetSkeletonSubContainer = styled(Layout.Stack, {
  padding: '24px 16px 24px 16px',
});

export const WidgetSkeletonLayoutContainer = styled(Layout.Group, {
  paddingTop: '30px',
  borderBottom: '1px solid #E5E5E6',
  borderWidth: '2px',
  margin: 0,
});
